import { Controller } from '@hotwired/stimulus';
import { extend, noop } from 'lodash';

/*
Este plugin gestiona el componente del selector de destinatarios
*/
/* global Mn, Cifra, swal, $, set_overlay_ajax */
const SelectorDestinatarios = Mn.View.extend({
  template: noop,
  ui: {
    tipoSeleccionBtn: '#tipo-seleccion-body .radio-tipo-seleccion',
    buscarDestinatarariosBtn: '#btn-buscar-destinatararios',
    seleccionados: '#seleccionados',
    form: 'form',
  },
  events: {
    'change @ui.tipoSeleccionBtn': 'changeTipoSeleccion',
    'click @ui.buscarDestinatarariosBtn': 'buscarDestinatarios',
    'keydown #filtros input': (e) => {
      if (e.which === 13) e.preventDefault();
    },
    'keyup #filtros input': 'controlKeyBuscar',
    'submit @ui.form': 'validateSubmit',
  },
  validateSubmit() {
    const _self = this;
    const $tiposDestinatarios = $('#tipos-destinatarios');
    if ($('#seleccionados').find('input[type=checkbox]:checked').length) {
      // Si existe el selector de tipos de destinatarios tenemos que comprobar
      // que fue marcada alguna de sus opciones
      if (!$tiposDestinatarios.length) {
        set_overlay_ajax(this.$el);
        return;
      }

      if ($tiposDestinatarios.find('input[type=checkbox]:checked').length) {
        set_overlay_ajax(this.$el);
        this.setDisableSubmitButton(true);
        return;
      }
    }
    swal(
      {
        title: 'Selección incompleta',
        text: 'La selección está incompleta, complete la selección, por favor',
        type: 'warning',
        confirmButtonText: 'De acuerdo',
        showCancelButton: false,
      },
      // eslint-disable-next-line prefer-arrow-callback, func-names
      function (isConfirm) {
        if (isConfirm) {
          _self.setDisableSubmitButton(false);
        }
      },
    );
    // Este warning no lo toco por si rompo algo
    return false;
  },
  changeTipoSeleccion(e) {
    const $boton = $(e.currentTarget);
    const $wrapper = $boton.closest('#tipo-seleccion-body');
    const $tipoSeleccion = this.$('#tipo-seleccion-body input').serializeArray();
    const $method = ($wrapper.data('method') || 'get').toUpperCase();
    const remoteElement = $('<a>', {
      href: $wrapper.data('url'),
      'data-method': $method,
      'data-params': $.param($tipoSeleccion, true),
    });
    const _self = this;
    set_overlay_ajax(_self.$el);
    remoteElement.on('ajax:success', () => {
      _self.$('#seleccion').empty();
    });
    $.rails.handleRemote(remoteElement);
  },
  setDisableSubmitButton(state) {
    // el botón de submit del modal no forma parte del componente, no podemos usar this.$
    $('#btn-submit-seleccion').prop('disabled', state);
  },
  buscarDestinatarios(e) {
    const $boton = $(e.currentTarget);
    const $form = this.$('form');
    const params = $form.find('#tipo_seleccion, #filtros').find('input').serializeArray();
    const $method = ($boton.data('method') || 'get').toUpperCase();

    const remoteElement = $('<a>', {
      href: $boton.data('url'),
      'data-method': $method,
      'data-params': $.param(params, true),
    });
    // const _self = this;
    // remoteElement.on ('ajax:success', function() {
    //   _self.$('#filtro-estructura-body').collapse();
    // });
    set_overlay_ajax(this.$el);
    $.rails.handleRemote(remoteElement);
  },
  onRender() {
    const view = this;
    // Le ponemos un punto más que el valor por defecto de bootstrap para que lo muestre
    // por encima si es lanzado desde otro modal, como por ejemplo, desde el de edición
    // de eventos en la agenda
    this.$el.closest('.modal').css('z-index', '1056');
    $(this.$el.closest('.modal')).one('shown.bs.modal', () => {
      view.$('#filtros input[type=text]:first-child').focus();
    });
  },
  controlKeyBuscar(e) {
    if (e.which === 13) {
      e.preventDefault();
      this.$('#btn-buscar-destinatararios').click();
    }
  },
});

// Esto estaba aquí tirado, habrá que moverlo pero de momento lo dejo tal como estaba
Cifra.App.on('start:seleccion_destinatarios:filtros', (_controller, _action) => {
  $('#filtros input[type=text]:first-child').focus();
});

export default class extends Controller {
  connect() {
    const options = extend({
      el: this.element,
    }, $(this.element).data());

    this.component = new SelectorDestinatarios(options);
    this.component.render();
  }

  render() {
    this.component.render();
  }
}
